(async function() {
    const sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const GA4_MEASUREMENT_ID = 'G-G9KH2ZWF4J';
    let ga4Initialized = false;
    let ga4Blocked = false;

    const initGA4 = () => {
        if (!GA4_MEASUREMENT_ID || ga4Initialized || ga4Blocked) {
            return;
        }

        try {
            if (!window.gtag) {
                const script = document.createElement('script');
                script.async = true;
                script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
                document.head.appendChild(script);

                window.dataLayer = window.dataLayer || [];
                window.gtag = function() { dataLayer.push(arguments); };
                window.gtag('js', new Date());
                
                window.gtag('config', GA4_MEASUREMENT_ID, {
                    send_page_view: false,
                    page_title: 'Registration Page Embeded',
                    custom_parameter_source: 'iframe_only'
                });
                
                ga4Initialized = true;
            } else {
                window.gtag('config', GA4_MEASUREMENT_ID, {
                    send_page_view: false
                });
            }
        } catch (error) {
        }
    };

    const sendGA4Event = (eventData) => {
        if (ga4Blocked) {
            return;
        }
        
        if (!window.gtag || !GA4_MEASUREMENT_ID) {
            return;
        }

        if (!eventData || !eventData.event) {
            return;
        }

        try {
            const eventParams = {
                page_location: eventData.page_location,
                page_path: eventData.page_path,
                page_title: eventData.page_title
            };

            if (eventData.locale) {
                eventParams.custom_parameter_locale = eventData.locale;
            }

            window.gtag('event', eventData.event, eventParams);
        } catch (error) {
        }
    };


    const configurations = {
        env: 'production',
        affiliateUrl: 'https://partners.uppromote.com',
        apiHost: 'https://api.uppromote.com'

        // env: 'test',
        // affiliateUrl: 'https://affiliate-test.uppromote.com',
        // apiHost: 'https://api-staging.uppromote.com'

        // env: 'dev',
        // affiliateUrl: 'http://localhost:3001',
        // apiHost: 'https://uppromote-react-api.test'
    }

    if (
        !configurations ||
        !['dev', 'test', 'production'].includes(configurations.env) ||
        !configurations.affiliateUrl
    ) {
        throw new Error('Configuration invalid')
    }

    var wrapperIframe = document.querySelector('.wrapper-registration');
    if (wrapperIframe) {
        var shopDomain = wrapperIframe.getAttribute('data-shopDomain')
        const wrapperLoader = document.querySelector('.loader-registration');
        window.addEventListener('message', function(event) {
            if (event.data && event.data.type == "send_height") {
                wrapperIframe.style.height = event.data.iframeHeight + 'px';
                if (event.data.isRedirect) {
                    wrapperIframe.scrollIntoView();
                    wrapperIframe.style.border = '1px solid #BBBFC3';
                }
            }

            if (event.data && event.data.type == "scroll_to") {
                document.documentElement.scrollTop = event.data.position + wrapperIframe.getBoundingClientRect().top + window.scrollY;
            }

            if (event.data && event.data.type == "scroll_to_captcha") {
                let distanceToTop = 0;
                let wrapperIframeTemp = wrapperIframe;
                while (wrapperIframeTemp) {
                    distanceToTop += wrapperIframeTemp.offsetTop;
                    wrapperIframeTemp = wrapperIframeTemp.offsetParent;
                }
                document.documentElement.scrollTop = event.data.position + distanceToTop;
            }

            if (event.data && event.data.type === "GA4_EVENT" && event.data.payload) {
                const allowedOrigins = [
                    'https://partners.uppromote.com',
                    'https://affiliate-test.uppromote.com',
                    'https://admin.uppromote.dev', 
                    'http://localhost:3001'
                ];
            
                console.log('Received GA4 event from origin:', event.origin);
                
                if (!allowedOrigins.includes(event.origin)) {
                    ga4Blocked = true;
                    
                    window.gtag = function() {
                        console.log('gtag call blocked due to invalid origin');
                    };
                    
                    return;
                }
                
                console.log('GA4 event APPROVED from origin:', event.origin);
                if (!ga4Initialized) {
                    console.log('Initializing GA4 for first valid event');
                    initGA4();
                }
                
                sendGA4Event(event.data.payload);
            }
        });

        const params = new URLSearchParams({
            shopDomain
        });

		const fetchURL = `${configurations.apiHost}/api/client/merchant-subdomain?${params.toString()}`;

        const fetchMerchantSubdomain = await fetch(fetchURL, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        });

        const dataResponse = await fetchMerchantSubdomain.json();
        if (dataResponse.status === 'ok') {
            if (!Shopify.designMode && (dataResponse.program.theme_type === 'basic_old' || dataResponse.program.is_inactive)) {
                wrapperLoader.remove();
                return;
            }
            // if (!Shopify.designMode) {
            //     document.querySelector('.wrapper-registration').style.height = '100vh'
            // }
            var iframe = document.createElement('iframe');
            iframe.id = "registration_form";
            const { affiliateUrl } = configurations;
            const { merchant_subdomain, merchant_custom_domain, customize_name, ip } = dataResponse;
            const shopName = shopDomain.replace('.myshopify.com', '');
            const embededDesign = Shopify.designMode ? '&embeded_design=1' : '';
            const customDomainParam = merchant_custom_domain ? `&custom_domain=${merchant_custom_domain}` : '';
            const customizeNameParam = customize_name ? `&customize_name=${customize_name}` : '';

            const frameUrl = new URL(`${affiliateUrl}/${merchant_subdomain}/register?embeded=1${embededDesign}&shop_name=${shopName}${customDomainParam}${customizeNameParam}&ip=${ip}&shop=${shopName}`);
            frameUrl.searchParams.set('ref', 'NzfewPKHJr')
            frameUrl.searchParams.set('p', '269040')
            iframe.src = frameUrl.toString();
            iframe.style.width = "100%";
            iframe.style.height = "100%";
            iframe.style.border = "none";
            Object.assign(wrapperLoader.style, {
                visibility: "hidden",
                opacity: 0,
                'pointer-events': 'none'
            });
            wrapperLoader.style.visibility = "hidden";
            wrapperIframe.appendChild(iframe);
            setTimeout(() => {
            wrapperIframe.style.visibility = "visible";
            // await sleep(1000); // await 1s before remove loading
            }, 50);

        }
    }
})();
